module.exports = __webpack_public_path__ + "img/icon-French.19b4a5cc.png";